import React from 'react';
import { Link } from 'react-router-dom';

const Start = () => <Link to="/contact" className="button-arrow-black start">Start a Project<img src="../img/svg/arrow-white.svg" alt="arrow"/></Link>

export default Start;